import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireAdmin } from "@/lib/auth";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminReset from "@/pages/admin/AdminReset";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminReservations from "@/pages/admin/AdminReservations";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminExtras from "@/pages/admin/AdminExtras";
import AdminContent from "@/pages/admin/AdminContent";
import AdminReports from "@/pages/admin/AdminReports";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/restablecer" element={<AdminReset />} />
          <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
            <Route index element={<Navigate to="reservas" replace />} />
            <Route path="reservas" element={<AdminReservations />} />
            <Route path="calendario" element={<AdminCalendar />} />
            <Route path="precios" element={<AdminPricing />} />
            <Route path="extras" element={<AdminExtras />} />
            <Route path="contenido" element={<AdminContent />} />
            <Route path="reportes" element={<AdminReports />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
